export default "__VITE_ASSET__VrVAy60Q__"